import { CreateSector, EstadisticasSector, Sector, UpdateSector } from '../models/Entities/Turnero';
import { apiRequest, buildURL } from './commons/CommonService.Functions';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'offices/Sectores';

export const GetSectores = async (token: string): Promise<Sector[]> => {
    return apiRequest<Sector[]>(BaseURL, token, 'GetSectores');
};

export const CreateSectorRequest = async (token: string, payload: CreateSector): Promise<Sector> => {
    return apiRequest<Sector>(BaseURL, token, 'CreateSectorRequest', {
        method: 'POST',
        body: JSON.stringify(payload)
    });
};

export const GetSectorById = async (token: string, sectorId: number): Promise<Sector> => {
    const requestURL = buildURL(BaseURL, sectorId);
    return apiRequest<Sector>(requestURL, token, 'GetSectorById');
};

export const UpdateSectorRequest = async (token: string, id: number, payload: UpdateSector): Promise<string> => {
    const requestURL = buildURL(BaseURL, id);
    return apiRequest<string>(requestURL, token, 'UpdateSectorRequest', {
        method: 'PUT',
        body: JSON.stringify(payload)
    });
};

export const DeleteSector = async (token: string, id: number): Promise<string> => {
    const requestURL = buildURL(BaseURL, id);
    return apiRequest<string>(requestURL, token, 'DeleteSector', {
        method: 'DELETE'
    });
};

export const GetEstadisticasSector = async (token: string, sectorId: number): Promise<EstadisticasSector> => {
    const requestURL = buildURL(BaseURL, sectorId, 'estadisticas');
    return apiRequest<EstadisticasSector>(requestURL, token, 'GetEstadisticasSector');
};
